/* ==========================================================================
   ATELIER SAJADA - BOX BUILDER
   Moteur de navigation, etapes conditionnelles, recapitulatif, progression.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'ats-bb-state-v1';

  /* ---------- utilitaires ---------- */

  function euros(cents) {
    var v = (cents || 0) / 100;
    var s = v.toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return s + ' \u20AC';
  }

  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html !== undefined) n.innerHTML = html;
    return n;
  }

  function isEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /* ---------- controleur ---------- */

  function BoxBuilder(root) {
    this.root = root;
    this.id = root.getAttribute('data-section-id') || 'bb';

    var cfgNode = root.querySelector('[data-ats-bb-config]');
    this.config = cfgNode ? JSON.parse(cfgNode.textContent) : {};

    this.steps = [];
    this.current = 0;
    this.selections = {};
    this.answers = {};
    this.form = null;

    this.collect();
    this.cacheNodes();
    this.restore();
    this.ensureLockedProducts();
    this.bind();
    this.render();
  }

  /* ---------- collecte des etapes ---------- */

  BoxBuilder.prototype.collect = function () {
    var nodes = this.root.querySelectorAll('[data-ats-bb-step]');
    this.steps = [];
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      this.steps.push({
        node: n,
        blockId: n.getAttribute('data-block-id') || String(i),
        label: n.getAttribute('data-label') || 'Etape',
        conditionMode: n.getAttribute('data-condition-mode') || 'always',
        conditionStep: parseInt(n.getAttribute('data-condition-step'), 10) || 0,
        answerName: n.getAttribute('data-answer-name') || '',
        answerValue: n.getAttribute('data-answer-value') || '',
        isReview: n.getAttribute('data-review') === 'true',
        minItems: parseInt(n.getAttribute('data-min-items'), 10) || 0,
        minMessage: n.getAttribute('data-min-message') || 'Choisissez au moins un article pour continuer.',
        index: i
      });
    }
  };

  BoxBuilder.prototype.cacheNodes = function () {
    var r = this.root;
    this.bar = r.querySelector('[data-ats-bb-bar]');
    this.barTrack = r.querySelector('[data-ats-bb-bar-track]');
    this.btnPrev = r.querySelector('[data-ats-bb-prev]');
    this.btnNext = r.querySelector('[data-ats-bb-next]');
    this.btnBarPrev = r.querySelector('[data-ats-bb-bar-prev]');
    this.btnBarNext = r.querySelector('[data-ats-bb-bar-next]');
    this.recapList = r.querySelector('[data-ats-bb-recap-list]');
    this.recapEmpty = r.querySelector('[data-ats-bb-recap-empty]');
    this.recapCount = r.querySelector('[data-ats-bb-recap-count]');
    this.recapTotal = r.querySelector('[data-ats-bb-recap-total]');
    this.recapFoot = r.querySelector('[data-ats-bb-recap-foot]');
    this.recapBox = r.querySelector('.ats-bb__recap');
    this.btnToggle = r.querySelector('[data-ats-bb-toggle]');
    this.mobileCount = r.querySelector('[data-ats-bb-mobile-count]');
    this.mobileTotal = r.querySelector('[data-ats-bb-mobile-total]');
    this.btnClear = r.querySelector('[data-ats-bb-clear]');
    this.progress = r.querySelector('[data-ats-bb-progress]');
    this.guide = r.querySelector('[data-ats-bb-guide]');
    this.gauge = r.querySelector('[data-ats-bb-gauge]');
    this.nextLabel = this.btnNext ? this.btnNext.textContent.trim() : 'Suivant';
  };

  /* ---------- etapes visibles ---------- */

  BoxBuilder.prototype.stepHasSelection = function (humanNumber) {
    var s = this.steps[humanNumber - 1];
    if (!s) return false;
    var arr = this.selections[s.blockId];
    return !!(arr && arr.length);
  };

  BoxBuilder.prototype.isVisible = function (step) {
    if (isEditor()) return true;
    if (step.conditionMode === 'if_selection') {
      return this.stepHasSelection(step.conditionStep);
    }
    if (step.conditionMode === 'if_no_selection') {
      return !this.stepHasSelection(step.conditionStep);
    }
    if (step.conditionMode === 'if_answer') {
      var donnee = String(this.answers[step.answerName] || '').toLowerCase();
      var attendue = String(step.answerValue || '').toLowerCase().trim();
      return attendue !== '' && donnee.indexOf(attendue) !== -1;
    }
    return true;
  };

  BoxBuilder.prototype.visibleSteps = function () {
    var out = [];
    for (var i = 0; i < this.steps.length; i++) {
      if (this.isVisible(this.steps[i])) out.push(this.steps[i]);
    }
    return out;
  };

  /* ---------- navigation ---------- */

  BoxBuilder.prototype.stepCount = function (step) {
    var arr = this.selections[step.blockId] || [];
    var n = 0;
    for (var i = 0; i < arr.length; i++) n += arr[i].qty || 1;
    return n;
  };

  BoxBuilder.prototype.stepWarn = function (step, message) {
    /* si l'etape a un selecteur de format, le message va sous celui-ci */
    if (step.node.querySelector('[data-ats-bb-formats]') && this.formatWarn(message)) return;

    var node = step.node.querySelector('[data-ats-bb-stepwarn]');
    if (!node) { window.alert(message); return; }
    node.textContent = message;
    node.hidden = false;
    if (node.scrollIntoView) node.scrollIntoView({ block: 'center', behavior: 'smooth' });
    setTimeout(function () { node.hidden = true; }, 4000);
  };

  BoxBuilder.prototype.goTo = function (position, opts) {
    var vis = this.visibleSteps();
    if (!vis.length) return;
    if (position < 0) position = 0;
    if (position > vis.length - 1) position = vis.length - 1;

    /* on ne quitte pas une etape dont le minimum n'est pas atteint */
    if (position > this.current && !isEditor()) {
      for (var q = this.current; q < position; q++) {
        var etape = vis[q];
        var sansReponse = this.questionsManquantes(etape);
        if (sansReponse.length) {
          if (q !== this.current) { this.goTo(q); return; }
          this.stepWarn(etape, 'Merci de repondre : ' + sansReponse.join(', ') + '.');
          return;
        }

        if (etape.minItems > 0 && this.stepCount(etape) < etape.minItems) {
          if (q !== this.current) { this.goTo(q); return; }
          this.stepWarn(etape, etape.minMessage);
          return;
        }

        /* un lot commence doit etre complete avant de continuer */
        if (etape.node.querySelector('[data-ats-bb-formats]') && !this.lotComplet()) {
          if (q !== this.current) { this.goTo(q); return; }
          var manquant = this.format.qty - this.lotCount();
          this.stepWarn(etape, 'Il reste ' + manquant + ' article' + (manquant > 1 ? 's' : '') +
            ' a choisir pour completer votre lot de ' + this.format.qty + '.');
          return;
        }

      }
    }
    this.current = position;
    if (this.recapBox && this.recapBox.classList.contains('is-open') && window.innerWidth <= 900) {
      this.recapBox.classList.remove('is-open');
      if (this.btnToggle) this.btnToggle.setAttribute('aria-expanded', 'false');
    }
    this.render();
    if (!opts || opts.scroll !== false) this.scrollTop();
    if (!isEditor()) {
      var target = vis[position];
      try {
        history.replaceState(null, '', '#etape-' + (target.index + 1));
      } catch (e) {}
    }
  };

  BoxBuilder.prototype.goToStepIndex = function (index) {
    var vis = this.visibleSteps();
    for (var i = 0; i < vis.length; i++) {
      if (vis[i].index === index) { this.goTo(i); return; }
    }
  };

  BoxBuilder.prototype.goToBlockId = function (blockId) {
    var vis = this.visibleSteps();
    for (var i = 0; i < vis.length; i++) {
      if (vis[i].blockId === blockId) { this.goTo(i, { scroll: false }); return; }
    }
  };

  BoxBuilder.prototype.scrollTop = function () {
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  };

  /* ---------- rendu ---------- */

  BoxBuilder.prototype.render = function () {
    var vis = this.visibleSteps();
    if (this.current > vis.length - 1) this.current = vis.length - 1;
    if (this.current < 0) this.current = 0;

    for (var i = 0; i < this.steps.length; i++) {
      this.steps[i].node.hidden = true;
      this.steps[i].node.classList.remove('is-active');
    }
    var active = vis[this.current];
    if (active) {
      active.node.hidden = false;
      active.node.classList.add('is-active');
      this.lazyLoad(active.node);
    }

    this.renderBar(vis);
    this.renderNav(vis);
    this.renderRecap();
    this.renderReview();
    this.syncCards();
    this.syncQuestions();
    this.renderProgress();
    this.renderFormats();
    this.renderLotPrices();
    this.persist();
  };

  BoxBuilder.prototype.lazyLoad = function (node) {
    var imgs = node.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].src = imgs[i].getAttribute('data-src');
      imgs[i].removeAttribute('data-src');
    }
  };

  BoxBuilder.prototype.renderBar = function (vis) {
    if (!this.barTrack) return;
    this.barTrack.innerHTML = '';
    var self = this;

    for (var i = 0; i < vis.length; i++) {
      var step = vis[i];
      var done = i < self.current;
      var isCur = i === self.current;

      var item = el('button', 'ats-bb__barstep');
      item.type = 'button';
      item.setAttribute('data-pos', String(i));
      if (isCur) item.classList.add('is-current');
      if (done) item.classList.add('is-done');

      var dot = el('span', 'ats-bb__bardot');
      dot.innerHTML = done
        ? '<svg width="12" height="12" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1.5 5L4 7.5L8.5 2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : String(i + 1);

      var lbl = el('span', 'ats-bb__barlabel');
      lbl.textContent = step.label;

      item.appendChild(dot);
      item.appendChild(lbl);
      this.barTrack.appendChild(item);
    }

    /* On deplace uniquement la barre, jamais la page :
       scrollIntoView ferait remonter tout l'ecran sur mobile. */
    if (this.barPos !== this.current) {
      this.barPos = this.current;
      var cur = this.barTrack.querySelector('.is-current');
      if (cur && this.barTrack.scrollWidth > this.barTrack.clientWidth) {
        var cible = cur.offsetLeft - (this.barTrack.clientWidth - cur.offsetWidth) / 2;
        if (cible < 0) cible = 0;
        if (this.barTrack.scrollTo) {
          this.barTrack.scrollTo({ left: cible, behavior: 'smooth' });
        } else {
          this.barTrack.scrollLeft = cible;
        }
      }
    }
  };

  BoxBuilder.prototype.renderNav = function (vis) {
    var first = this.current === 0;
    var last = this.current === vis.length - 1;
    if (this.btnPrev) this.btnPrev.hidden = first;

    var active = vis[this.current];
    var review = this.root.querySelector('[data-ats-bb-review]');
    var onReview = false;
    if (active && review) {
      onReview = active.isReview || active.node.contains(review);
    }
    this.navIsCta = !!onReview;

    /* sur l'etape de recapitulatif, la barre du bas ferait doublon
       avec le total et le bouton deja presents dans la page */
    if (this.recapBox) this.recapBox.classList.toggle('is-hidden-step', !!onReview);

    if (this.btnNext) {
      if (onReview) {
        this.btnNext.hidden = false;
        this.btnNext.textContent = review.getAttribute('data-cta-label') || 'Ajouter au panier';
      } else {
        this.btnNext.hidden = last;
        this.btnNext.textContent = this.nextLabel;
      }
    }
    if (this.recapFoot) this.recapFoot.classList.toggle('is-last', last);
  };

  BoxBuilder.prototype.allItems = function () {
    var out = [];
    for (var i = 0; i < this.steps.length; i++) {
      var arr = this.selections[this.steps[i].blockId];
      if (arr) out = out.concat(arr);
    }
    return out;
  };

  BoxBuilder.prototype.itemTotal = function (it) {
    var t = (it.price || 0) * (it.qty || 1);
    var ex = it.extras || [];
    for (var i = 0; i < ex.length; i++) {
      t += (ex[i].price || 0) * (ex[i].qty || 1) * (it.qty || 1);
    }
    return t;
  };

  /* Prix d'un article tel qu'il doit s'afficher : pour un article du lot,
     c'est le prix unitaire reel du format avec le prix catalogue barre,
     exactement comme sur les cartes de la grille. */
  BoxBuilder.prototype.itemPriceHtml = function (it) {
    var base = (it.price || 0) * (it.qty || 1);

    if (this.format && this.format.qty && this.isLotGrid(it.gridId)) {
      var unitaire = Math.round(this.format.price / this.format.qty);
      var reel = unitaire * (it.qty || 1);
      var h = '<span class="ats-bb__cardnow">' + euros(reel) + '</span>';
      if (base > reel) h += ' <span class="ats-bb__cardwas">' + euros(base) + '</span>';
      return h;
    }
    return euros(base);
  };

  BoxBuilder.prototype.boxTotal = function () {
    var items = this.allItems(), t = 0;

    /* avec un format de lot, les articles du lot ne sont pas factures a
       l'unite : c'est le prix fixe du lot qui compte, une seule fois. */
    if (this.format && this.format.qty) {
      for (var i = 0; i < items.length; i++) {
        if (!this.isLotGrid(items[i].gridId)) t += this.itemTotal(items[i]);
      }
      if (this.lotCount() > 0) t += this.format.price || 0;
      return t;
    }

    for (var j = 0; j < items.length; j++) t += this.itemTotal(items[j]);
    return t;
  };

  BoxBuilder.prototype.renderRecap = function () {
    var items = this.allItems();
    var count = 0;
    for (var i = 0; i < items.length; i++) count += items[i].qty || 1;

    if (this.recapEmpty) this.recapEmpty.hidden = items.length > 0;
    if (this.recapCount) {
      this.recapCount.textContent = count === 0
        ? ''
        : count + (count > 1 ? ' articles dans la box' : ' article dans la box');
    }
    if (this.btnClear) this.btnClear.hidden = items.length === 0;

    var total = this.boxTotal();
    if (this.recapTotal) this.recapTotal.textContent = euros(total);
    if (this.mobileTotal) this.mobileTotal.textContent = euros(total);
    if (this.mobileCount) {
      this.mobileCount.textContent = count === 0
        ? 'Votre box est vide'
        : count + (count > 1 ? ' articles dans la box' : ' article dans la box');
    }

    if (!this.recapList) return;
    this.recapList.innerHTML = '';
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      var row = el('div', 'ats-bb__recapitem');
      row.setAttribute('data-uid', it.uid);

      var thumb = el('div', 'ats-bb__recapthumb');
      if (it.image) {
        var im = el('img');
        im.src = it.image;
        im.alt = '';
        im.loading = 'lazy';
        thumb.appendChild(im);
      }

      var body = el('div', 'ats-bb__recapbody');

      /* titre a gauche, prix du produit aligne a droite */
      var tete = el('div', 'ats-bb__recaptop');
      tete.appendChild(el('span', 'ats-bb__recaptitle', it.title || ''));
      tete.appendChild(el('span', 'ats-bb__recapmontant', this.itemPriceHtml(it)));
      body.appendChild(tete);

      /* taille et quantite sur une meme ligne discrete */
      var meta = [];
      if (it.variantTitle) meta.push(it.variantTitle);
      meta.push('x' + (it.qty || 1));
      body.appendChild(el('span', 'ats-bb__recapvariant', meta.join(' \u00b7 ')));

      var shown = it.properties || {};
      for (var k in shown) {
        if (!Object.prototype.hasOwnProperty.call(shown, k)) continue;
        if (k.charAt(0) === '_') continue;
        var p = el('span', 'ats-bb__recapprop');
        p.textContent = k + ' : ' + shown[k];
        body.appendChild(p);
      }

      /* options payantes, chacune avec son montant a droite */
      var exr = it.extras || [];
      if (exr.length) body.appendChild(el('div', 'ats-bb__recapsep'));

      for (var xr = 0; xr < exr.length; xr++) {
        var lr = el('div', 'ats-bb__recapextra');
        lr.appendChild(el('span', 'ats-bb__recapextraname', '+ ' + (exr[xr].title || 'Option')));
        lr.appendChild(el('span', 'ats-bb__recapextraprix',
          euros((exr[xr].price || 0) * (exr[xr].qty || 1) * (it.qty || 1))));
        body.appendChild(lr);
      }

      var rm = null;
      if (!it.locked) {
        rm = el('button', 'ats-bb__recapremove');
        rm.type = 'button';
        rm.setAttribute('aria-label', 'Retirer ' + (it.title || 'cet article'));
        rm.setAttribute('data-remove', it.uid);
        rm.innerHTML = '&times;';
      }

      row.appendChild(thumb);
      row.appendChild(body);
      if (rm) row.appendChild(rm);
      this.recapList.appendChild(row);
    }
  };

  /* ---------- barre de progression (paliers) ---------- */

  BoxBuilder.prototype.renderProgress = function () {
    if (!this.progress) return;
    var c = this.config;
    if (!c.tiers || !c.tiers.length) return;

    var base = c.progress_base === 'box_only' ? 0 : (c.cart_total || 0);
    var total = base + this.boxTotal();
    var t1 = c.tiers[0].amount, t2 = c.tiers[1].amount, t3 = c.tiers[2].amount;
    var pct;

    if (total <= 0) pct = 0;
    else if (total < t1) pct = total * 30 / t1;
    else if (total < t2) pct = 30 + (total - t1) * 30 / (t2 - t1);
    else if (total < t3) pct = 60 + (total - t2) * 30 / (t3 - t2);
    else pct = Math.min(100, 90 + (total - t3) * 10 / t3);

    var msg;
    if (total <= 0) msg = c.msg_empty;
    else if (total < t1) msg = c.msg_t1.replace('{montant}', '<strong>' + euros(t1 - total) + '</strong>');
    else if (total < t2) msg = c.msg_t2.replace('{montant}', '<strong>' + euros(t2 - total) + '</strong>');
    else if (total < t3) msg = c.msg_t3.replace('{montant}', '<strong>' + euros(t3 - total) + '</strong>');
    else msg = c.msg_done;

    var msgNode = this.progress.querySelector('[data-ats-bb-progress-msg]');
    if (msgNode) msgNode.innerHTML = msg;

    var fill = this.progress.querySelector('[data-ats-bb-progress-fill]');
    if (fill) fill.style.width = pct + '%';

    var dots = this.progress.querySelectorAll('[data-ats-bb-milestone]');
    var reached = [total >= t1, total >= t2, total >= t3];
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-done', !!reached[i]);
      var inner = dots[i].querySelector('.ats-bb__pdot');
      if (inner) {
        inner.innerHTML = reached[i]
          ? '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1.5 5L4 7.5L8.5 2.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          : '';
      }
    }
  };

  /* ---------- persistance ---------- */

  BoxBuilder.prototype.persist = function () {
    if (isEditor()) return;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({
        selections: this.selections,
        answers: this.answers,
        current: this.current,
        format: this.format ? this.format.id : null,
        ts: Date.now()
      }));
    } catch (e) {}
  };

  BoxBuilder.prototype.restore = function () {
    var startIndex = null;
    var params = new URLSearchParams(window.location.search);
    if (params.get('etape')) startIndex = parseInt(params.get('etape'), 10) - 1;
    if (window.location.hash.indexOf('#etape-') === 0) {
      startIndex = parseInt(window.location.hash.replace('#etape-', ''), 10) - 1;
    }

    if (!isEditor()) {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
          var data = JSON.parse(raw);
          if (data && data.ts && (Date.now() - data.ts) < 1000 * 60 * 60 * 24 * 7) {
            this.selections = data.selections || {};
            this.answers = data.answers || {};
            this.formatId = data.format || null;
            if (startIndex === null && typeof data.current === 'number') this.current = data.current;
          }
        }
      } catch (e) {}
    }

    if (startIndex !== null && !isNaN(startIndex)) {
      var vis = this.visibleSteps();
      for (var i = 0; i < vis.length; i++) {
        if (vis[i].index === startIndex) { this.current = i; break; }
      }
    }
  };

  BoxBuilder.prototype.reset = function () {
    /* on referme proprement la fiche produit et on rend son formulaire
       a son emplacement d'origine, sinon il reste orphelin dans le modal */
    if (this.modal && !this.modal.hidden) this.closeModal();
    if (this.form && this.formHome) {
      this.form.hidden = true;
      this.formHome.appendChild(this.form);
    }
    this.form = null;
    this.modalCard = null;
    this.modalVariant = null;
    this.modalStart = null;
    this.sending = false;

    this.selections = {};
    this.answers = {};
    this.current = 0;
    this.barPos = null;
    this.ensureLockedProducts();

    /* on remet chaque formulaire dans son etat neutre */
    var formulaires = this.root.querySelectorAll('[data-ats-bb-perso]');
    for (var f = 0; f < formulaires.length; f++) {
      var champs = formulaires[f].querySelectorAll('[data-ats-bb-input]');
      for (var i = 0; i < champs.length; i++) champs[i].value = '';

      var compteurs = formulaires[f].querySelectorAll('[data-ats-bb-count]');
      for (var c = 0; c < compteurs.length; c++) compteurs[c].textContent = '0';

      var boites = formulaires[f].querySelectorAll('[data-ats-bb-selfwrite]');
      for (var bx = 0; bx < boites.length; bx++) {
        boites[bx].checked = false;
        var ch = boites[bx].closest('[data-ats-bb-field]');
        if (ch) this.syncSelfWrite(ch);
      }

      var options = formulaires[f].querySelectorAll('[data-ats-bb-choiceopt]');
      for (var o = 0; o < options.length; o++) {
        options[o].classList.toggle('is-on', options[o].getAttribute('data-none') === 'true');
      }

      var blocs = formulaires[f].querySelectorAll('.is-missing');
      for (var b = 0; b < blocs.length; b++) blocs[b].classList.remove('is-missing');
    }

    this.render();
    this.persist();
    this.scrollTop();
  };

  /* ---------- API pour les blocs de contenu ---------- */

  BoxBuilder.prototype.addItem = function (stepBlockId, item) {
    if (!this.selections[stepBlockId]) this.selections[stepBlockId] = [];
    item.uid = item.uid || (stepBlockId + '-' + item.variantId + '-' + Date.now());
    item.stepBlockId = stepBlockId;
    this.selections[stepBlockId].push(item);
    this.afterChange();
  };

  BoxBuilder.prototype.removeItem = function (uid) {
    var existing = this.findItem(uid);
    if (existing && existing.locked) return;
    for (var k in this.selections) {
      if (!Object.prototype.hasOwnProperty.call(this.selections, k)) continue;
      this.selections[k] = this.selections[k].filter(function (i) { return i.uid !== uid; });
    }
    this.afterChange();
  };

  BoxBuilder.prototype.afterChange = function () {
    this.cleanupHiddenSteps();
    this.render();
    this.root.dispatchEvent(new CustomEvent('ats:box:change', {
      bubbles: true,
      detail: { items: this.allItems(), total: this.boxTotal() }
    }));
  };

  /* ajoute automatiquement les produits marques "obligatoire (verrouille)"
     sur une grille, s'ils n'y sont pas deja. Ne passe jamais par addItem
     pour eviter de declencher un rendu avant que le reste soit pret. */
  BoxBuilder.prototype.ensureLockedProducts = function () {
    var grids = this.root.querySelectorAll('[data-ats-bb-grid][data-locked-product-id]');
    for (var i = 0; i < grids.length; i++) {
      var grid = grids[i];
      var pid = grid.getAttribute('data-locked-product-id');
      if (!pid || pid === '0') continue;

      var step = grid.closest('[data-ats-bb-step]');
      if (!step) continue;
      var stepId = step.getAttribute('data-block-id');
      var gridId = grid.getAttribute('data-grid-id');

      var card = grid.querySelector('[data-ats-bb-card][data-product-id="' + pid + '"]');
      if (!card) continue;

      var uid = gridId + ':' + pid;
      if (this.findItem(uid)) continue;

      if (!this.selections[stepId]) this.selections[stepId] = [];
      this.selections[stepId].push({
        uid: uid,
        gridId: gridId,
        stepLabel: step.getAttribute('data-label') || '',
        productId: pid,
        variantId: card.getAttribute('data-variant-id'),
        title: card.getAttribute('data-title'),
        variantTitle: '',
        price: parseInt(card.getAttribute('data-price'), 10) || 0,
        image: card.getAttribute('data-image'),
        qty: 1,
        properties: {},
        choices: {},
        extras: [],
        locked: true
      });
    }
  };

  /* une etape masquee ne doit pas conserver de donnees */
  BoxBuilder.prototype.cleanupHiddenSteps = function () {
    for (var i = 0; i < this.steps.length; i++) {
      var s = this.steps[i];
      if (s.conditionMode === 'always') continue;
      if (!this.isVisible(s) && this.selections[s.blockId] && this.selections[s.blockId].length) {
        delete this.selections[s.blockId];
        var fields = s.node.querySelectorAll('input, textarea, select');
        for (var j = 0; j < fields.length; j++) {
          if (fields[j].type === 'checkbox' || fields[j].type === 'radio') fields[j].checked = false;
          else fields[j].value = '';
        }
      }
    }
  };

  /* ---- ancrage du panneau en bas de l'ecran sur mobile ----
     Le thème place la section dans des conteneurs qui empechent
     position:fixed de fonctionner. On sort donc le panneau dans le body. */

  BoxBuilder.prototype.setupDock = function () {
    if (!this.recapBox) return;
    if (isEditor()) {
      document.documentElement.classList.add('ats-bb-editor');
      return;
    }

    var self = this;
    this.recapHome = this.recapBox.parentNode;

    function apply() {
      var mobile = window.innerWidth <= 900;
      var docked = self.recapBox.parentNode === document.body;

      if (mobile && !docked) {
        self.recapBox.setAttribute('style', self.root.getAttribute('style') || '');
        self.recapBox.classList.add('ats-bb__recap--docked');
        document.body.appendChild(self.recapBox);
        document.body.classList.add('ats-bb-has-dock');
      } else if (!mobile && docked) {
        self.recapBox.removeAttribute('style');
        self.recapBox.classList.remove('ats-bb__recap--docked', 'is-open');
        self.recapHome.appendChild(self.recapBox);
        document.body.classList.remove('ats-bb-has-dock');
      }
    }

    apply();

    var timer = null;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(apply, 150);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target !== self.root && !e.target.contains(self.root)) return;
      if (self.recapBox.parentNode === document.body) self.recapBox.remove();
      if (self.guide && self.guide.parentNode === document.body) self.guide.remove();
      if (self.gauge && !self.root.contains(self.gauge) && self.gauge.parentNode) self.gauge.remove();
      if (self.modal && self.modal.parentNode === document.body) self.modal.remove();
      document.body.classList.remove('ats-bb-has-dock');
    });
  };

  /* ---- grilles de produits ---- */

  BoxBuilder.prototype.findItem = function (uid) {
    for (var k in this.selections) {
      if (!Object.prototype.hasOwnProperty.call(this.selections, k)) continue;
      for (var i = 0; i < this.selections[k].length; i++) {
        if (this.selections[k][i].uid === uid) return this.selections[k][i];
      }
    }
    return null;
  };

  BoxBuilder.prototype.cardUid = function (card) {
    var grid = card.closest('[data-ats-bb-grid]');
    return grid.getAttribute('data-grid-id') + ':' + card.getAttribute('data-product-id');
  };

  BoxBuilder.prototype.gridCount = function (gridId) {
    var n = 0;
    for (var k in this.selections) {
      if (!Object.prototype.hasOwnProperty.call(this.selections, k)) continue;
      for (var i = 0; i < this.selections[k].length; i++) {
        if (this.selections[k][i].gridId === gridId) n += this.selections[k][i].qty || 1;
      }
    }
    return n;
  };

  BoxBuilder.prototype.toggleCard = function (card) {
    if (card.getAttribute('data-available') === 'false') return;

    var grid = card.closest('[data-ats-bb-grid]');
    var step = card.closest('[data-ats-bb-step]');
    if (!grid || !step) return;

    var uid = this.cardUid(card);
    if (this.findItem(uid)) { this.removeItem(uid); return; }

    /* option obligatoire non choisie */
    if (card.getAttribute('data-needs-variant') === 'true' && !card.getAttribute('data-variant-id')) {
      this.openModal(card);
      return;
    }

    this.selectCard(card);
  };

  BoxBuilder.prototype.selectCard = function (card) {
    var grid = card.closest('[data-ats-bb-grid]');
    var step = card.closest('[data-ats-bb-step]');
    if (!grid || !step) return false;

    var gridId = grid.getAttribute('data-grid-id');
    var stepId = step.getAttribute('data-block-id');
    var uid = this.cardUid(card);

    /* selection unique dans cette grille (jamais un article verrouille) */
    if (grid.getAttribute('data-mode') === 'single') {
      var others = [];
      for (var k in this.selections) {
        if (!Object.prototype.hasOwnProperty.call(this.selections, k)) continue;
        for (var i = 0; i < this.selections[k].length; i++) {
          var cand = this.selections[k][i];
          if (cand.gridId === gridId && !cand.locked) others.push(cand.uid);
        }
      }
      for (var j = 0; j < others.length; j++) this.removeItemSilent(others[j]);
    }

    /* limite d'articles : le format du lot prime sur la limite de grille */
    if (this.format && this.format.qty && this.isLotGrid(gridId)) {
      if (this.lotCount() >= this.format.qty) {
        var msg = 'Votre lot de ' + this.format.qty +
          ' est complet. Choisissez un format plus grand ci-dessus, ou retirez un article.';
        if (!this.formatWarn(msg)) window.alert(msg);
        return false;
      }
    } else {
      var max = parseInt(grid.getAttribute('data-max'), 10) || 0;
      if (max > 0 && this.gridCount(gridId) >= max) {
        window.alert('Vous pouvez selectionner au maximum ' + max + ' article' + (max > 1 ? 's' : '') + ' ici.');
        return false;
      }
    }

    var lu = this.form ? this.readForm() : { props: {}, extras: [] };

    this.addItem(stepId, {
      uid: uid,
      gridId: gridId,
      stepLabel: step.getAttribute('data-label') || '',
      productId: card.getAttribute('data-product-id'),
      variantId: card.getAttribute('data-variant-id'),
      title: card.getAttribute('data-title'),
      variantTitle: card.getAttribute('data-variant-title'),
      price: parseInt(card.getAttribute('data-price'), 10) || 0,
      image: card.getAttribute('data-image'),
      qty: 1,
      properties: lu.props,
      choices: lu.choices,
      extras: lu.extras
    });
    return true;
  };

  /* ---- fiche produit ---- */

  BoxBuilder.prototype.ensureModal = function () {
    if (this.modal) return this.modal;

    var m = el('div', 'ats-bb__modal');
    m.hidden = true;
    m.innerHTML =
      '<div class="ats-bb__modalback" data-ats-bb-modal-close></div>' +
      '<div class="ats-bb__modalpanel" role="dialog" aria-modal="true" aria-label="Fiche produit">' +
        '<button type="button" class="ats-bb__modalclose" data-ats-bb-modal-close aria-label="Fermer">&times;</button>' +
        '<div class="ats-bb__modalscroll">' +
          '<div class="ats-bb__modaltop">' +
            '<div class="ats-bb__modalthumbs" data-ats-bb-thumbs></div>' +
            '<div class="ats-bb__modalmedia"><img alt=""></div>' +
          '</div>' +
          '<div class="ats-bb__modalbody">' +
            '<h3 class="ats-bb__modaltitle"></h3>' +
            '<div class="ats-bb__pricerow">' +
              '<p class="ats-bb__modalprice"></p>' +
              '<span class="ats-bb__modalextra" data-ats-bb-modal-extra hidden></span>' +
              '<span class="ats-bb__help">' +
                '<button type="button" class="ats-bb__guidelink" data-ats-bb-guide-open hidden>' +
                  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                    '<rect x="2" y="7" width="20" height="10" rx="2" stroke="currentColor" stroke-width="1.7"/>' +
                    '<path d="M7 7v3M11 7v4M15 7v3M19 7v4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/>' +
                  '</svg>' +
                  '<span></span>' +
                '</button>' +
                '<span class="ats-bb__helpsep" data-ats-bb-help-sep hidden>|</span>' +
                '<a class="ats-bb__walink" data-ats-bb-wa target="_blank" rel="noopener" hidden>' +
                  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                    '<path d="M12 3.5a8.5 8.5 0 0 0-7.3 12.83L3.5 20.5l4.32-1.13A8.5 8.5 0 1 0 12 3.5Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
                    '<path d="M9.2 8.4c.2-.45.4-.46.6-.47h.5c.16 0 .38-.02.57.45.2.5.67 1.66.73 1.78.06.12.1.26.02.42-.08.16-.12.26-.24.4-.12.14-.25.31-.36.41-.12.12-.24.25-.1.48.13.24.6.98 1.28 1.59.88.78 1.62 1.02 1.85 1.14.23.12.37.1.5-.06.14-.16.58-.68.74-.91.16-.23.32-.19.54-.12.22.08 1.4.66 1.64.78.24.12.4.18.46.28.06.1.06.57-.14 1.12-.2.55-1.16 1.05-1.6 1.1-.45.05-.86.23-2.9-.57-2.46-.97-4.01-3.49-4.13-3.65-.12-.16-.98-1.3-.98-2.48 0-1.18.62-1.76.84-2Z" fill="currentColor"/>' +
                  '</svg>' +
                  '<span></span>' +
                '</a>' +
              '</span>' +
            '</div>' +
            '<details class="ats-bb__modaldetails">' +
              '<summary class="ats-bb__modalsummary">' +
                '<span>Description du produit</span>' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '</summary>' +
              '<div class="ats-bb__modaldesc"></div>' +
            '</details>' +
            '<div class="ats-bb__modalperso" data-ats-bb-modal-perso></div>' +
            '<p class="ats-bb__persoNote" data-ats-bb-perso-note hidden></p>' +
          '</div>' +
        '</div>' +
        '<div class="ats-bb__modalfoot">' +
          '<p class="ats-bb__modalerror" data-ats-bb-modal-error hidden></p>' +
          '<div class="ats-bb__modalopts">' +
            '<select class="ats-bb__modalselect" data-ats-bb-modal-select aria-label="Choisir une option"></select>' +
          '</div>' +
          '<button type="button" class="ats-bb__btn ats-bb__btn--solid" data-ats-bb-modal-apply hidden>Appliquer les modifications</button>' +
          '<button type="button" class="ats-bb__btn ats-bb__btn--solid" data-ats-bb-modal-add>Ajouter a ma box</button>' +
        '</div>' +
      '</div>';

    m.setAttribute('style', this.root.getAttribute('style') || '');
    document.body.appendChild(m);
    this.modal = m;

    var self = this;

    m.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-ats-bb-modal-select]');
      if (!sel) return;
      sel.classList.remove('is-error');
      if (!sel.value) { self.modalVariant = null; self.refreshModalFoot(); return; }
      var opt = sel.options[sel.selectedIndex];
      self.modalVariant = {
        id: sel.value,
        title: opt.getAttribute('data-variant-title') || '',
        price: parseInt(opt.getAttribute('data-variant-price'), 10) || 0
      };
      self.showVariantImage(opt.getAttribute('data-variant-image'));
      self.refreshFormPrice();
      self.refreshModalFoot();
    });

    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-ats-bb-modal-close]')) { self.closeModal(); return; }

      var thumb = e.target.closest('[data-ats-bb-thumb]');
      if (thumb) {
        var thumbs = m.querySelectorAll('[data-ats-bb-thumb]');
        for (var i = 0; i < thumbs.length; i++) thumbs[i].classList.remove('is-on');
        thumb.classList.add('is-on');
        m.querySelector('.ats-bb__modalmedia img').src = thumb.getAttribute('data-large');
        return;
      }

      if (e.target.closest('[data-ats-bb-guide-open]')) { self.openGuide(); return; }
      if (e.target.closest('[data-ats-bb-modal-apply]')) { self.applyModal(); return; }
      if (e.target.closest('[data-ats-bb-modal-add]')) self.confirmModal();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.modal && !self.modal.hidden) self.closeModal();
    });

    return m;
  };

  /* affiche la photo liee a une variante, et met la miniature correspondante en avant */
  BoxBuilder.prototype.showVariantImage = function (url) {
    if (!this.modal || !url) return;

    var img = this.modal.querySelector('.ats-bb__modalmedia img');
    if (!img || img.src === url) return;
    img.src = url;
    img.hidden = false;

    var vignettes = this.modal.querySelectorAll('[data-ats-bb-thumb]');
    for (var i = 0; i < vignettes.length; i++) {
      vignettes[i].classList.toggle('is-on', vignettes[i].getAttribute('data-large') === url);
    }
  };

  BoxBuilder.prototype.openModal = function (card) {
    if (card.getAttribute('data-available') === 'false') return;

    var dataNode = card.querySelector('[data-ats-bb-product]');
    if (!dataNode) { this.selectCard(card); return; }

    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (e) { return; }

    var grid = card.closest('[data-ats-bb-grid]');
    var m = this.ensureModal();
    this.modalCard = card;
    this.modalData = data;
    this.modalVariant = null;

    var img = m.querySelector('.ats-bb__modalmedia img');
    var thumbs = m.querySelector('[data-ats-bb-thumbs]');
    var gallery = data.images && data.images.length ? data.images : (data.image ? [{ large: data.image, thumb: data.image, alt: '' }] : []);

    thumbs.innerHTML = '';
    if (gallery.length) {
      img.src = gallery[0].large;
      img.alt = gallery[0].alt || data.title || '';
      img.hidden = false;
    } else {
      img.hidden = true;
    }

    if (gallery.length > 1) {
      thumbs.hidden = false;
      for (var g = 0; g < gallery.length; g++) {
        var t = el('button', 'ats-bb__thumb' + (g === 0 ? ' is-on' : ''));
        t.type = 'button';
        t.setAttribute('data-ats-bb-thumb', '');
        t.setAttribute('data-large', gallery[g].large);
        t.innerHTML = '<img src="' + gallery[g].thumb + '" alt="" loading="lazy">';
        thumbs.appendChild(t);
      }
    } else {
      thumbs.hidden = true;
    }

    var guide = this.guide;
    var lien = m.querySelector('[data-ats-bb-guide-open]');
    if (lien) {
      var afficher = !!guide && card.getAttribute('data-guide') === 'true';
      lien.hidden = !afficher;
      if (afficher) {
        lien.querySelector('span').textContent =
          guide.getAttribute('data-guide-label') || 'Guide des tailles';
      }
    }

    var wa = m.querySelector('[data-ats-bb-wa]');
    var sep = m.querySelector('[data-ats-bb-help-sep]');
    if (wa) {
      var pos = this.config.wa_position || 'fiche';
      var voirWa = !!(this.config.wa_enabled && this.config.wa_url)
        && (pos === 'fiche' || pos === 'fiche_recap');
      wa.hidden = !voirWa;
      if (voirWa) {
        wa.href = this.config.wa_url;
        wa.querySelector('span').textContent = this.config.wa_label || 'Une question ?';
      }
      if (sep) sep.hidden = !(voirWa && lien && !lien.hidden);
    }

    m.querySelector('.ats-bb__modaltitle').textContent = data.title || '';
    m.querySelector('.ats-bb__modaldesc').innerHTML = data.description || '';

    var variants = data.variants || [];
    var multi = card.getAttribute('data-needs-variant') === 'true';
    var opts = m.querySelector('.ats-bb__modalopts');
    var select = m.querySelector('[data-ats-bb-modal-select]');
    var details = m.querySelector('.ats-bb__modaldetails');

    select.innerHTML = '';
    select.classList.remove('is-error');
    if (details) details.open = false;

    if (multi && variants.length) {
      opts.hidden = false;

      var ph = el('option');
      ph.value = '';
      ph.textContent = grid.getAttribute('data-variant-label') || 'Choisir une option';
      select.appendChild(ph);

      for (var i = 0; i < variants.length; i++) {
        var vr = variants[i];
        var o = el('option');
        o.value = vr.id;
        o.setAttribute('data-variant-title', vr.title);
        o.setAttribute('data-variant-price', vr.price);
        if (vr.image) o.setAttribute('data-variant-image', vr.image);
        o.textContent = vr.title + (vr.available ? '' : ' \u2014 epuise');
        if (!vr.available) o.disabled = true;
        select.appendChild(o);
      }
    } else {
      opts.hidden = true;
      if (variants.length) {
        this.modalVariant = { id: variants[0].id, title: '', price: variants[0].price };
      }
    }

    /* si l'article est deja dans la box, on preselectionne son option */
    var item = this.findItem(this.cardUid(card));
    if (item && item.variantId && multi) {
      select.value = String(item.variantId);
      if (select.value) {
        this.modalVariant = { id: item.variantId, title: item.variantTitle, price: item.price };
        var choisie = select.options[select.selectedIndex];
        var urlVar = choisie ? choisie.getAttribute('data-variant-image') : '';
        if (urlVar) this.showVariantImage(urlVar);
      }
    }

    m.querySelector('.ats-bb__modalprice').textContent =
      euros(parseInt(card.getAttribute('data-price'), 10) || 0);

    /* formulaire de personnalisation de cette grille */
    var accueil = m.querySelector('[data-ats-bb-modal-perso]');
    var form = this.formForGrid(grid.getAttribute('data-grid-id'));
    if (form) {
      if (!form.dataset.home) {
        form.dataset.home = '1';
        this.formHome = form.parentNode;
      }
      accueil.appendChild(form);
      form.hidden = false;
      this.form = form;
      this.fillForm(item);
    } else {
      this.form = null;
      accueil.innerHTML = '';
    }

    var mention = m.querySelector('[data-ats-bb-perso-note]');
    if (mention) {
      mention.textContent = this.config.perso_note || '';
      mention.hidden = true;
    }

    this.refreshFormPrice();
    this.modalStart = item ? this.modalState() : null;
    this.refreshModalFoot();
    m.hidden = false;
    document.body.classList.add('ats-bb-modal-open');
  };

  /* photographie de la fiche : variante, saisies et options */
  BoxBuilder.prototype.modalState = function () {
    var lu = this.form ? this.readForm() : { props: {}, choices: {}, extras: [] };
    var ex = [];
    for (var i = 0; i < lu.extras.length; i++) {
      ex.push(lu.extras[i].variantId + 'x' + (lu.extras[i].qty || 1));
    }
    ex.sort();
    return JSON.stringify({
      v: this.modalVariant ? String(this.modalVariant.id) : '',
      p: lu.props,
      c: lu.choices,
      e: ex
    });
  };

  BoxBuilder.prototype.modalDirty = function () {
    if (!this.modalStart) return false;
    return this.modalState() !== this.modalStart;
  };

  /* applique les changements sans deplacer l'article dans la box */
  BoxBuilder.prototype.applyModal = function () {
    var card = this.modalCard;
    if (!card) return;

    var item = this.findItem(this.cardUid(card));
    if (!item) return;

    var multi = card.getAttribute('data-needs-variant') === 'true';
    if (multi && !this.modalVariant) return;

    var manque = this.formMissing();
    if (manque.length) {
      var alerte = this.modal.querySelector('[data-ats-bb-modal-error]');
      if (alerte) {
        alerte.textContent = 'Merci de renseigner : ' + manque.join(', ') + '.';
        alerte.hidden = false;
        setTimeout(function () { alerte.hidden = true; }, 4000);
      }
      return;
    }

    if (this.modalVariant) {
      item.variantId = this.modalVariant.id;
      item.variantTitle = this.modalVariant.title || '';
      if (this.modalVariant.price) item.price = this.modalVariant.price;

      card.setAttribute('data-variant-id', this.modalVariant.id);
      card.setAttribute('data-variant-title', this.modalVariant.title || '');
      if (this.modalVariant.price) card.setAttribute('data-price', this.modalVariant.price);
    }

    var lu = this.form ? this.readForm() : { props: {}, choices: {}, extras: [] };
    item.properties = lu.props;
    item.choices = lu.choices;
    item.extras = lu.extras;

    this.afterChange();
    this.closeModal();
  };

  BoxBuilder.prototype.refreshModalFoot = function () {
    var m = this.modal;
    if (!m) return;

    var card = this.modalCard;
    var item = card ? this.findItem(this.cardUid(card)) : null;
    var btn = m.querySelector('[data-ats-bb-modal-add]');
    var apply = m.querySelector('[data-ats-bb-modal-apply]');

    if (this.modalVariant && this.modalVariant.price) {
      m.querySelector('.ats-bb__modalprice').textContent = euros(this.modalVariant.price);
    }

    btn.textContent = item ? 'Retirer de ma box' : 'Ajouter a ma box';
    btn.classList.toggle('ats-bb__btn--ghost', !!item);
    btn.classList.toggle('ats-bb__btn--solid', !item);

    /* le bouton n'apparait qu'en cas de changement reel */
    if (apply) apply.hidden = !(item && this.modalDirty());
  };

  BoxBuilder.prototype.confirmModal = function () {
    var card = this.modalCard;
    if (!card) return;

    var item = this.findItem(this.cardUid(card));
    if (item) { this.removeItem(item.uid); this.closeModal(); return; }

    var multi = card.getAttribute('data-needs-variant') === 'true';
    if (multi && !this.modalVariant) {
      var sel = this.modal.querySelector('[data-ats-bb-modal-select]');
      if (sel) {
        sel.classList.add('is-error');
        setTimeout(function () { sel.classList.remove('is-error'); }, 2500);
        try { sel.focus(); } catch (e) {}
      }
      return;
    }

    var manque = this.formMissing();
    if (manque.length) {
      var alerte = this.modal.querySelector('[data-ats-bb-modal-error]');
      if (alerte) {
        alerte.textContent = 'Merci de renseigner : ' + manque.join(', ') + '.';
        alerte.hidden = false;
        setTimeout(function () { alerte.hidden = true; }, 4000);
      }
      var premier = this.modal.querySelector('.is-missing');
      if (premier && premier.scrollIntoView) premier.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }

    if (this.modalVariant) {
      card.setAttribute('data-variant-id', this.modalVariant.id);
      card.setAttribute('data-variant-title', this.modalVariant.title || '');
      if (this.modalVariant.price) {
        card.setAttribute('data-price', this.modalVariant.price);
        var pn = card.querySelector('[data-ats-bb-cardprice]');
        if (pn) pn.textContent = euros(this.modalVariant.price);
      }
    }

    if (this.selectCard(card)) this.closeModal();
  };

  BoxBuilder.prototype.openGuide = function () {
    var guide = this.guide;
    if (!guide) return;

    if (guide.parentNode !== document.body) {
      guide.setAttribute('style', this.root.getAttribute('style') || '');
      document.body.appendChild(guide);
    }
    guide.hidden = false;

    var self = this;
    if (!guide.dataset.bound) {
      guide.dataset.bound = '1';
      guide.addEventListener('click', function (e) {
        if (e.target.closest('[data-ats-bb-guide-close]')) self.closeGuide();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !guide.hidden) self.closeGuide();
      });
    }
  };

  BoxBuilder.prototype.closeGuide = function () {
    if (this.guide) this.guide.hidden = true;
  };

  BoxBuilder.prototype.closeModal = function () {
    if (!this.modal) return;

    if (this.form && this.formHome) {
      this.form.hidden = true;
      this.formHome.appendChild(this.form);
    }
    this.form = null;

    this.modal.hidden = true;
    this.modalCard = null;
    this.modalVariant = null;
    this.modalStart = null;
    document.body.classList.remove('ats-bb-modal-open');
  };


  BoxBuilder.prototype.removeItemSilent = function (uid) {
    for (var k in this.selections) {
      if (!Object.prototype.hasOwnProperty.call(this.selections, k)) continue;
      this.selections[k] = this.selections[k].filter(function (i) { return i.uid !== uid; });
    }
  };

  BoxBuilder.prototype.changeQty = function (uid, delta) {
    var item = this.findItem(uid);
    if (!item || item.locked) return;
    var next = (item.qty || 1) + delta;
    if (next < 1) { this.removeItem(uid); return; }

    /* article du lot : le quota du format fait foi, jamais un de plus */
    if (delta > 0 && this.format && this.format.qty && this.isLotGrid(item.gridId)) {
      if (this.lotCount() + delta > this.format.qty) {
        var plein = 'Votre lot de ' + this.format.qty +
          ' est complet. Choisissez un format plus grand ci-dessus, ou retirez un article.';
        if (!this.formatWarn(plein)) window.alert(plein);
        return;
      }
      item.qty = next;
      this.afterChange();
      return;
    }

    var grid = this.root.querySelector('[data-grid-id="' + item.gridId + '"]');
    if (grid && delta > 0) {
      var max = parseInt(grid.getAttribute('data-max'), 10) || 0;
      if (max > 0 && this.gridCount(item.gridId) >= max) return;
    }
    item.qty = next;
    this.afterChange();
  };

  /* remet les cartes en accord avec l'etat reel de la box */
  BoxBuilder.prototype.syncCards = function () {
    var cards = this.root.querySelectorAll('[data-ats-bb-card]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var item = this.findItem(this.cardUid(card));
      var stepper = card.querySelector('[data-ats-bb-stepper]');
      var val = card.querySelector('[data-ats-bb-qtyval]');
      var choice = card.querySelector('[data-ats-bb-cardchoice]');

      card.classList.toggle('is-selected', !!item);
      if (stepper) stepper.hidden = !item;
      if (val && item) val.textContent = item.qty || 1;

      if (choice) {
        if (item && item.variantTitle) {
          choice.textContent = item.variantTitle;
          choice.hidden = false;
        } else {
          choice.hidden = true;
        }
      }
    }

    this.syncAccordions();
  };

  /* pastille indiquant le nombre d'articles choisis dans chaque accordeon */
  BoxBuilder.prototype.syncAccordions = function () {
    var accs = this.root.querySelectorAll('[data-ats-bb-acc]');
    for (var i = 0; i < accs.length; i++) {
      var acc = accs[i];
      var badge = acc.querySelector('[data-ats-bb-acc-badge]');
      if (!badge) continue;

      var grid = acc.querySelector('[data-ats-bb-grid]');
      var n = grid ? this.gridCount(grid.getAttribute('data-grid-id')) : 0;

      if (n > 0) {
        badge.textContent = n;
        badge.hidden = false;
        acc.classList.add('has-selection');
      } else {
        badge.hidden = true;
        acc.classList.remove('has-selection');
      }
    }
  };

  /* ---- questions d'orientation ---- */

  BoxBuilder.prototype.syncQuestions = function () {
    var blocs = this.root.querySelectorAll('[data-ats-bb-question]');
    for (var i = 0; i < blocs.length; i++) {
      var nom = blocs[i].getAttribute('data-question-name');
      var choisie = this.answers[nom] || '';
      var opts = blocs[i].querySelectorAll('[data-ats-bb-qopt]');
      for (var j = 0; j < opts.length; j++) {
        opts[j].classList.toggle('is-on', opts[j].getAttribute('data-value') === choisie);
      }
      if (choisie) blocs[i].classList.remove('is-missing');
    }
  };

  /* questions obligatoires sans reponse dans l'etape donnee */
  BoxBuilder.prototype.questionsManquantes = function (step) {
    var manque = [];
    var blocs = step.node.querySelectorAll('[data-ats-bb-question]');

    for (var i = 0; i < blocs.length; i++) {
      var b = blocs[i];
      b.classList.remove('is-missing');
      if (b.getAttribute('data-required') !== 'true') continue;

      var nom = b.getAttribute('data-question-name');
      if (this.answers[nom]) continue;

      var lbl = b.querySelector('.ats-bb__fieldlabel');
      manque.push(lbl ? lbl.textContent.replace('*', '').trim() : 'une question');
      b.classList.add('is-missing');
    }
    return manque;
  };

  BoxBuilder.prototype.setAnswer = function (nom, valeur) {
    if (this.answers[nom] === valeur) return;
    this.answers[nom] = valeur;

    /* une etape masquee par ce changement ne doit rien conserver */
    this.cleanupHiddenSteps();
    this.render();
    this.root.dispatchEvent(new CustomEvent('ats:box:answer', {
      bubbles: true,
      detail: { name: nom, value: valeur }
    }));
  };

  BoxBuilder.prototype.bindGrids = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var qopt = e.target.closest('[data-ats-bb-qopt]');
      if (qopt) {
        var bloc = qopt.closest('[data-ats-bb-question]');
        if (bloc) self.setAnswer(bloc.getAttribute('data-question-name'), qopt.getAttribute('data-value'));
        return;
      }

      if (e.target.closest('[data-ats-bb-tocart]')) {
        self.addToCart(e.target.closest('[data-ats-bb-tocart]'));
        return;
      }
      if (e.target.closest('[data-ats-bb-restart]')) {
        if (window.confirm('Vider votre box et recommencer \u00e0 z\u00e9ro ?')) self.reset();
        return;
      }
      var rmRev = e.target.closest('[data-ats-bb-review-list] [data-remove]');
      if (rmRev) { self.removeItem(rmRev.getAttribute('data-remove')); return; }

      var edt = e.target.closest('[data-ats-bb-review-edit]');
      if (edt) { self.editItem(edt.getAttribute('data-ats-bb-review-edit')); return; }

      var qRev = e.target.closest('[data-ats-bb-review-qty]');
      if (qRev) {
        self.changeQty(qRev.getAttribute('data-uid'), parseInt(qRev.getAttribute('data-ats-bb-review-qty'), 10));
        return;
      }

      var qtyBtn = e.target.closest('[data-ats-bb-qty]');
      if (qtyBtn) {
        e.stopPropagation();
        var c1 = qtyBtn.closest('[data-ats-bb-card]');
        if (c1) self.changeQty(self.cardUid(c1), parseInt(qtyBtn.getAttribute('data-ats-bb-qty'), 10));
        return;
      }

      var card = e.target.closest('[data-ats-bb-card]');
      if (!card || !self.root.contains(card)) return;
      if (card.getAttribute('data-locked') === 'true') return;

      var grid = card.closest('[data-ats-bb-grid]');
      var mode = grid ? grid.getAttribute('data-modal') : 'never';
      var multi = card.getAttribute('data-needs-variant') === 'true';
      var avecPerso = grid && grid.getAttribute('data-has-perso') === 'true';
      var wantModal = avecPerso || mode === 'always' || (mode === 'variants' && multi);

      /* deja dans la box : la fiche permet de changer d'option ou de retirer.
         Sans options, le clic retire directement. */
      if (self.findItem(self.cardUid(card)) && !wantModal) {
        self.removeItem(self.cardUid(card));
        return;
      }

      if (wantModal) self.openModal(card);
      else self.toggleCard(card);
    });
  };

  /* ---- recapitulatif final et envoi au panier ---- */

  BoxBuilder.prototype.renderReview = function () {
    var review = this.root.querySelector('[data-ats-bb-review]');
    if (!review) return;

    var list = review.querySelector('[data-ats-bb-review-list]');
    var items = this.allItems();
    var total = this.boxTotal();

    var totals = review.querySelectorAll('[data-ats-bb-review-total]');
    for (var t = 0; t < totals.length; t++) totals[t].textContent = euros(total);

    if (!list) return;
    list.innerHTML = '';

    if (!items.length) {
      list.appendChild(el('p', 'ats-bb__reviewempty', 'Votre box est vide. Revenez aux etapes precedentes pour la composer.'));
      return;
    }

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var row = el('div', 'ats-bb__reviewitem');

      var thumb = el('div', 'ats-bb__reviewthumb');
      if (it.image) {
        var im = el('img');
        im.src = it.image;
        im.alt = '';
        im.loading = 'lazy';
        thumb.appendChild(im);
      }

      var body = el('div', 'ats-bb__reviewbody');
      body.appendChild(el('span', 'ats-bb__reviewname', it.title || ''));
      if (it.variantTitle) body.appendChild(el('span', 'ats-bb__reviewvariant', it.variantTitle));

      var rprops = it.properties || {};
      for (var k in rprops) {
        if (!Object.prototype.hasOwnProperty.call(rprops, k)) continue;
        if (k.charAt(0) === '_') continue;
        var p = el('span', 'ats-bb__reviewprop');
        p.textContent = k + ' : ' + rprops[k];
        body.appendChild(p);
      }

      var edit = el('button', 'ats-bb__reviewedit');
      edit.type = 'button';
      edit.setAttribute('data-ats-bb-review-edit', it.uid);
      edit.textContent = 'Modifier';
      body.appendChild(edit);

      var qty = el('div', 'ats-bb__reviewqty');
      if (it.locked) {
        qty.innerHTML = '<span class="ats-bb__steppval">' + (it.qty || 1) + '</span>';
      } else {
        qty.innerHTML =
          '<button type="button" class="ats-bb__steppbtn" data-ats-bb-review-qty="-1" data-uid="' + it.uid + '" aria-label="Diminuer">&minus;</button>' +
          '<span class="ats-bb__steppval">' + (it.qty || 1) + '</span>' +
          '<button type="button" class="ats-bb__steppbtn" data-ats-bb-review-qty="1" data-uid="' + it.uid + '" aria-label="Augmenter">+</button>';
      }
      var price = el('span', 'ats-bb__reviewprice', this.itemPriceHtml(it));

      var rm = null;
      if (!it.locked) {
        rm = el('button', 'ats-bb__reviewremove');
        rm.type = 'button';
        rm.setAttribute('data-remove', it.uid);
        rm.setAttribute('aria-label', 'Retirer ' + (it.title || 'cet article'));
        rm.innerHTML = '&times;';
      }

      row.appendChild(thumb);
      row.appendChild(body);
      row.appendChild(qty);
      row.appendChild(price);
      if (rm) row.appendChild(rm);
      list.appendChild(row);

      /* les options achetees : une ligne chacune, etiquetee pour ne pas
         les confondre avec un article de la box */
      var ex = it.extras || [];
      for (var e = 0; e < ex.length; e++) {
        var nb = (ex[e].qty || 1) * (it.qty || 1);

        var sub = el('div', 'ats-bb__optline');
        sub.appendChild(el('span', 'ats-bb__optbadge', 'Option'));
        sub.appendChild(el('span', 'ats-bb__optname', ex[e].title || 'Option'));
        sub.appendChild(el('span', 'ats-bb__optqty', nb > 1 ? 'x' + nb : ''));
        sub.appendChild(el('span', 'ats-bb__optprice',
          euros((ex[e].price || 0) * (ex[e].qty || 1) * (it.qty || 1))));

        list.appendChild(sub);
      }
    }
  };

  /* retrouve la carte produit d'un article de la box */
  BoxBuilder.prototype.cardForItem = function (it) {
    if (!it || !it.gridId || !it.productId) return null;
    return this.root.querySelector(
      '[data-grid-id="' + it.gridId + '"] [data-ats-bb-card][data-product-id="' + it.productId + '"]'
    );
  };

  BoxBuilder.prototype.editItem = function (uid) {
    var it = this.findItem(uid);
    if (!it) return;
    var card = this.cardForItem(it);
    if (card) this.openModal(card);
  };

  BoxBuilder.prototype.reviewError = function (msg) {
    var node = this.root.querySelector('[data-ats-bb-review-error]');
    if (!node) { window.alert(msg); return; }
    node.textContent = msg;
    node.hidden = false;
    if (node.scrollIntoView) node.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  BoxBuilder.prototype.addToCart = function (btn) {
    var review = this.root.querySelector('[data-ats-bb-review]');
    if (!review || this.sending) return;

    var errNode = review.querySelector('[data-ats-bb-review-error]');
    if (errNode) errNode.hidden = true;

    var items = this.allItems();
    var min = parseInt(review.getAttribute('data-min-items'), 10) || 0;

    if (items.length < min) {
      this.reviewError('Ajoutez au moins ' + min + ' article' + (min > 1 ? 's' : '') + ' a votre box.');
      return;
    }

    var missing = false;
    for (var c = 0; c < items.length; c++) {
      if (!items[c].variantId) missing = true;
    }
    if (missing) {
      this.reviewError('Un article n\'a pas d\'option selectionnee. Revenez le corriger.');
      return;
    }

    var etapes = this.visibleSteps();
    for (var z = 0; z < etapes.length; z++) {
      var sansRep = this.questionsManquantes(etapes[z]);
      if (sansRep.length) {
        this.reviewError('Etape ' + etapes[z].label + ' : merci de repondre a ' + sansRep.join(', ') + '.');
        return;
      }
      if (etapes[z].minItems > 0 && this.stepCount(etapes[z]) < etapes[z].minItems) {
        this.reviewError('Etape ' + etapes[z].label + ' : ' + etapes[z].minMessage);
        return;
      }
    }

    var boxName = review.getAttribute('data-box-name') || 'Box';
    var boxId = 'bx_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);

    var payload = { items: [] };
    var resume = [];       /* ce que le client a compose */
    var lignesSup = [];    /* les supplements choisis, avec leur prix */
    var totalSup = 0;

    /* ---- lot a prix fixe ----
       Les articles des grilles "compose le lot" ne partent pas en lignes
       separees : ils sont inscrits en proprietes sur la ligne du produit
       lot, qui porte le prix. Le reste (cross-sell) suit normalement. */
    var avecLot = !!(this.format && this.format.qty);
    if (avecLot) {
      var duLot = this.lotItems();

      if (duLot.length) {
        var n = this.lotCount();
        if (n !== this.format.qty) {
          if (n < this.format.qty) {
            this.reviewError('Completez votre lot : ' + n + ' article' + (n > 1 ? 's' : '') +
              ' choisi' + (n > 1 ? 's' : '') + ' sur ' + this.format.qty + '.');
          } else {
            this.reviewError('Votre lot contient ' + n + ' articles alors que le format en prevoit ' +
              this.format.qty + '. Retirez-en ' + (n - this.format.qty) + '.');
          }
          return;
        }
      }

      if (duLot.length) {
        var propsLot = { '_box_id': boxId, '_box_nom': boxName };
        var rang = 0;
        for (var L = 0; L < duLot.length; L++) {
          var nb = duLot[L].qty || 1;
          for (var r = 0; r < nb; r++) {
            rang++;
            propsLot[rang + '.'] = duLot[L].title || '';
          }
        }

        payload.items.push({
          id: parseInt(this.format.variantId, 10),
          quantity: 1,
          properties: propsLot
        });

        resume.push(this.format.title + ' : ' + rang + ' articles');
      }

      /* on retire les articles du lot de la boucle habituelle */
      var restants = [];
      for (var m = 0; m < items.length; m++) {
        if (!this.isLotGrid(items[m].gridId)) restants.push(items[m]);
      }
      items = restants;
    }

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var props = {
        '_box_id': boxId,
        '_box_nom': boxName
      };
      var merged = it.properties || {};
      for (var k in merged) {
        if (!Object.prototype.hasOwnProperty.call(merged, k) || !merged[k]) continue;
        props[k] = merged[k];
      }
      var ligneId = boxId + '_' + it.uid;
      var ex = it.extras || [];

      props['_box_ligne'] = ligneId;
      if (ex.length) props['_box_options'] = String(ex.length);

      payload.items.push({
        id: parseInt(it.variantId, 10),
        quantity: it.qty || 1,
        properties: props
      });

      /* trace lisible du produit et de ses personnalisations */
      var texte = it.title || '';
      if (it.variantTitle) texte += ' ' + it.variantTitle;
      if (it.qty > 1) texte += ' x' + it.qty;
      for (var kp in merged) {
        if (!Object.prototype.hasOwnProperty.call(merged, kp) || !merged[kp]) continue;
        if (kp.charAt(0) === '_') continue;
        texte += ' \u00b7 ' + kp + ' ' + merged[kp];
      }
      resume.push(texte);

      for (var e = 0; e < ex.length; e++) {
        if (!ex[e].variantId) continue;

        var montant = (ex[e].price || 0) * (ex[e].qty || 1) * (it.qty || 1);
        totalSup += montant;
        lignesSup.push((ex[e].title || 'Option') + ' ' + euros(montant));

        payload.items.push({
          id: parseInt(ex[e].variantId, 10),
          quantity: (ex[e].qty || 1) * (it.qty || 1),
          properties: {
            '_box_id': boxId,
            '_box_nom': boxName,
            '_box_parent': ligneId,
            '_box_parent_nom': it.title || ''
          }
        });
      }
    }

    this.sending = true;
    var original = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.innerHTML = '<span class="ats-bb__spin" aria-hidden="true"></span>Validation en cours...';
    }
    review.classList.add('is-sending');

    var self = this;
    var after = review.getAttribute('data-after') || 'home';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Ajout impossible');
          return data;
        });
      })
      .then(function () {
        /* Trace globale au panier : aucune interface ne permet de la retirer.
           Elle sert de reference pour verifier ce qui a reellement ete facture. */
        var attributs = {};
        attributs['Box composee'] = resume.join('  |  ');
        if (lignesSup.length) {
          attributs['Options payantes'] = lignesSup.join('  |  ') +
            '  =  ' + euros(totalSup);
        }
        for (var q in self.answers) {
          if (!Object.prototype.hasOwnProperty.call(self.answers, q)) continue;
          if (self.answers[q]) attributs[q] = self.answers[q];
        }
        attributs['Reference box'] = boxId;

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attributs })
        }).catch(function () { /* l'ajout est fait : on ne bloque pas sur la trace */ });
      })
      .then(function () {
        self.selections = {};
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}

        if (after === 'checkout') { window.location.href = '/checkout'; return; }
        if (after === 'cart') { window.location.href = '/cart'; return; }

        /* Par defaut : accueil avec le tiroir panier ouvert.
           On recharge la page pour que le tiroir affiche un panier a jour :
           l'ajout se fait par l'API, le theme n'en est pas informe autrement. */
        window.location.href = '/?panier=ouvert';
      })
      .catch(function (err) {
        self.sending = false;
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.textContent = original;
        }
        review.classList.remove('is-sending');
        self.reviewError(err.message || 'Une erreur est survenue. Reessayez.');
      });
  };

  /* ---- personnalisation, pilotee par la fiche produit ---- */

  BoxBuilder.prototype.formForGrid = function (gridId) {
    return this.root.querySelector('[data-ats-bb-perso][data-grid-id="' + gridId + '"]');
  };

  /* valeurs actuellement choisies dans le formulaire ouvert */
  BoxBuilder.prototype.formChoices = function () {
    var out = {};
    if (!this.form) return out;
    var blocs = this.form.querySelectorAll('[data-ats-bb-choice]');
    for (var i = 0; i < blocs.length; i++) {
      if (blocs[i].hidden) continue;
      var on = blocs[i].querySelector('[data-ats-bb-choiceopt].is-on');
      if (on && on.getAttribute('data-none') !== 'true') {
        out[blocs[i].getAttribute('data-prop-name')] = on.getAttribute('data-title');
      }
    }
    return out;
  };

  BoxBuilder.prototype.evalFormConditions = function () {
    if (!this.form) return;
    var valeurs = this.formChoices();
    var nodes = this.form.querySelectorAll('[data-cond-mode]');

    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (n.getAttribute('data-cond-mode') !== 'if_choice') { n.hidden = false; continue; }

      var courant = String(valeurs[n.getAttribute('data-cond-prop')] || '').toLowerCase();
      var brut = String(n.getAttribute('data-cond-value') || '').toLowerCase();

      /* plusieurs valeurs possibles, separees par des virgules :
         le bloc s'affiche si la reponse correspond a l'une d'elles */
      var attendus = brut.split(',');
      var ok = false;
      for (var a = 0; a < attendus.length; a++) {
        var att = attendus[a].trim();
        if (att !== '' && courant.indexOf(att) !== -1) { ok = true; break; }
      }

      if (n.hidden === !ok) continue;
      n.hidden = !ok;
      if (ok) continue;

      var input = n.querySelector('[data-ats-bb-input]');
      if (input) input.value = '';
      var opts = n.querySelectorAll('[data-ats-bb-choiceopt]');
      for (var j = 0; j < opts.length; j++) {
        opts[j].classList.toggle('is-on', opts[j].getAttribute('data-none') === 'true');
      }
    }
  };

  /* supplement lie a la longueur d'un champ texte */
  BoxBuilder.prototype.formSurcharge = function (wrap) {
    var variantId = wrap.getAttribute('data-sur-variant');
    var note = wrap.querySelector('[data-ats-bb-surcharge]');
    if (!variantId) return null;

    var input = wrap.querySelector('[data-ats-bb-input]');
    var len = input ? input.value.trim().length : 0;
    var free = parseInt(wrap.getAttribute('data-sur-free'), 10) || 0;

    if (wrap.hidden || len <= free) {
      if (note) note.hidden = true;
      return null;
    }

    var mode = wrap.getAttribute('data-sur-mode') || 'once';
    var qty = mode === 'per_char' ? (len - free) : 1;
    var price = parseInt(wrap.getAttribute('data-sur-price'), 10) || 0;
    var title = wrap.getAttribute('data-sur-title') || 'Supplement';

    if (note) {
      note.hidden = false;
      note.querySelector('.ats-bb__surchargetxt').textContent =
        'Au-dela de ' + free + ' caracteres : ' + title + ' ' +
        (qty > 1 ? '(x' + qty + ') ' : '') + euros(price * qty);
    }

    return { variantId: variantId, title: title, price: price, qty: qty };
  };

  /* lit tout le formulaire : proprietes visibles et produits a facturer */
  BoxBuilder.prototype.readForm = function () {
    var res = { props: {}, choices: {}, extras: [] };
    if (!this.form) return res;

    var champs = this.form.querySelectorAll('[data-ats-bb-field]');
    for (var i = 0; i < champs.length; i++) {
      var c = champs[i];
      if (c.hidden) continue;

      /* le client a declare qu'il remplira lui-meme : on envoie la mention
         a la place du texte, et aucun supplement n'est facture */
      var perso = c.querySelector('[data-ats-bb-selfwrite]');
      if (perso && perso.checked) {
        var mention = c.getAttribute('data-self-value');
        if (mention) res.props[c.getAttribute('data-prop-name')] = mention;
        continue;
      }

      var input = c.querySelector('[data-ats-bb-input]');
      var val = input ? input.value.trim() : '';
      if (val) res.props[c.getAttribute('data-prop-name')] = val;
      var sup = this.formSurcharge(c);
      if (sup) res.extras.push(sup);
    }

    var choix = this.form.querySelectorAll('[data-ats-bb-choice]');
    for (var j = 0; j < choix.length; j++) {
      var ch = choix[j];
      if (ch.hidden) continue;
      var on = ch.querySelector('[data-ats-bb-choiceopt].is-on');
      if (!on || on.getAttribute('data-none') === 'true') continue;

      var nomChoix = ch.getAttribute('data-prop-name');
      var titreChoix = on.getAttribute('data-title');
      var prixChoix = parseInt(on.getAttribute('data-price'), 10) || 0;

      res.choices[nomChoix] = titreChoix;

      if (prixChoix > 0) {
        /* option payante : ligne distincte, pour que le client voie ce qu'il paie */
        res.extras.push({
          variantId: on.getAttribute('data-variant-id'),
          title: titreChoix,
          price: prixChoix,
          qty: 1
        });
        /* toujours reporte sous le produit : si le client retire la ligne
           payante depuis le panier, la trace reste visible a la preparation */
        res.props[nomChoix] = titreChoix;
      } else {
        /* option gratuite : simple mention sous le produit */
        res.props[nomChoix] = titreChoix;
      }
    }
    return res;
  };

  /* champs obligatoires du formulaire ouvert */
  BoxBuilder.prototype.formMissing = function () {
    var manque = [];
    if (!this.form) return manque;

    var nodes = this.form.querySelectorAll('[data-ats-bb-field], [data-ats-bb-choice]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      n.classList.remove('is-missing');
      if (n.hidden) continue;

      /* case "je remplis moi-meme" cochee : le champ n'est plus attendu */
      var coche = n.querySelector('[data-ats-bb-selfwrite]');
      if (coche && coche.checked) continue;

      var estChoix = n.hasAttribute('data-ats-bb-choice');
      var requis = estChoix
        ? n.getAttribute('data-required') === 'true'
        : !!n.querySelector('[data-required="true"]');
      if (!requis) continue;

      var rempli;
      if (estChoix) {
        var on = n.querySelector('[data-ats-bb-choiceopt].is-on');
        rempli = !!on && on.getAttribute('data-none') !== 'true';
      } else {
        var input = n.querySelector('[data-ats-bb-input]');
        rempli = !!(input && input.value.trim());
      }

      if (!rempli) {
        var lbl = n.querySelector('.ats-bb__fieldlabel');
        manque.push(lbl ? lbl.textContent.replace('*', '').trim() : 'un champ');
        n.classList.add('is-missing');
      }
    }
    return manque;
  };

  /* remet le formulaire dans l'etat d'un article, ou a zero */
  BoxBuilder.prototype.fillForm = function (item) {
    if (!this.form) return;
    var props = (item && item.properties) || {};

    var champs = this.form.querySelectorAll('[data-ats-bb-field]');
    for (var i = 0; i < champs.length; i++) {
      var c = champs[i];
      var input = c.querySelector('[data-ats-bb-input]');
      var valeur = props[c.getAttribute('data-prop-name')] || '';

      /* si la valeur enregistree est la mention de la case, on recoche */
      var boite = c.querySelector('[data-ats-bb-selfwrite]');
      var mention = c.getAttribute('data-self-value');
      var etaitCoche = !!(boite && mention && valeur === mention);
      if (boite) boite.checked = etaitCoche;
      if (etaitCoche) valeur = '';

      if (input) input.value = valeur;
      var compteur = c.querySelector('[data-ats-bb-count]');
      if (compteur && input) compteur.textContent = input.value.length;
      c.classList.remove('is-missing');
      this.syncSelfWrite(c);
    }

    var memo = (item && item.choices) || {};
    var choix = this.form.querySelectorAll('[data-ats-bb-choice]');
    for (var j = 0; j < choix.length; j++) {
      var ch = choix[j];
      var cle = ch.getAttribute('data-prop-name');
      var voulu = memo[cle] || props[cle] || '';
      var opts = ch.querySelectorAll('[data-ats-bb-choiceopt]');
      var trouve = false;
      for (var k = 0; k < opts.length; k++) {
        var match = voulu && opts[k].getAttribute('data-title') === voulu;
        opts[k].classList.toggle('is-on', !!match);
        if (match) trouve = true;
      }
      if (!trouve) {
        for (var n2 = 0; n2 < opts.length; n2++) {
          opts[n2].classList.toggle('is-on', opts[n2].getAttribute('data-none') === 'true');
        }
      }
      ch.classList.remove('is-missing');
    }

    this.evalFormConditions();
    this.refreshFormPrice();
  };

  /* Le prix affiche reste celui du produit seul.
     Les options ajoutees apparaissent en dessous, sans gonfler le prix de base. */
  BoxBuilder.prototype.refreshFormPrice = function () {
    if (!this.modal) return;

    var base = this.modalVariant && this.modalVariant.price
      ? this.modalVariant.price
      : (this.modalCard ? parseInt(this.modalCard.getAttribute('data-price'), 10) || 0 : 0);

    var node = this.modal.querySelector('.ats-bb__modalprice');
    if (node) node.textContent = euros(base);

    var sup = 0;
    if (this.form) {
      var lu = this.readForm();
      for (var i = 0; i < lu.extras.length; i++) {
        sup += (lu.extras[i].price || 0) * (lu.extras[i].qty || 1);
      }
    }

    var extra = this.modal.querySelector('[data-ats-bb-modal-extra]');
    if (extra) {
      if (sup > 0) {
        extra.textContent = '+ ' + euros(sup) + ' d\'options';
        extra.hidden = false;
      } else {
        extra.hidden = true;
      }
    }

    /* rappel affiche seulement si le client a effectivement personnalise */
    var mention = this.modal.querySelector('[data-ats-bb-perso-note]');
    if (mention) {
      var perso = false;
      if (this.form) {
        var etat = this.readForm();
        if (etat.extras.length) perso = true;
        for (var k in etat.props) {
          if (Object.prototype.hasOwnProperty.call(etat.props, k) && etat.props[k]) perso = true;
        }
      }
      mention.hidden = !(perso && mention.textContent);
    }
  };

  /* Applique l'etat de la case : champ vide, grise et non modifiable
     quand le client declare qu'il remplira lui-meme. */
  BoxBuilder.prototype.syncSelfWrite = function (champ) {
    var boite = champ.querySelector('[data-ats-bb-selfwrite]');
    if (!boite) return;

    var input = champ.querySelector('[data-ats-bb-input]');
    var compteur = champ.querySelector('[data-ats-bb-count]');
    var actif = boite.checked;

    champ.classList.toggle('is-selfwrite', actif);
    if (input) {
      input.disabled = actif;
      if (actif) input.value = '';
    }
    if (compteur && input) compteur.textContent = input.value.length;
    if (actif) champ.classList.remove('is-missing');
  };

  BoxBuilder.prototype.bindPerso = function () {
    var self = this;
    var timer = null;

    document.addEventListener('input', function (e) {
      var input = e.target.closest('[data-ats-bb-input]');
      if (!input || !self.form || !self.form.contains(input)) return;

      var wrap = input.closest('[data-ats-bb-field]');
      if (!wrap) return;
      var compteur = wrap.querySelector('[data-ats-bb-count]');
      if (compteur) compteur.textContent = input.value.length;
      wrap.classList.remove('is-missing');

      clearTimeout(timer);
      timer = setTimeout(function () {
        self.refreshFormPrice();
        self.refreshModalFoot();
      }, 300);
    });

    document.addEventListener('change', function (e) {
      var boite = e.target.closest('[data-ats-bb-selfwrite]');
      if (!boite || !self.form || !self.form.contains(boite)) return;

      var champ = boite.closest('[data-ats-bb-field]');
      if (!champ) return;
      self.syncSelfWrite(champ);
      self.refreshFormPrice();
      self.refreshModalFoot();
    });

    document.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-ats-bb-choiceopt]');
      if (!opt || !self.form || !self.form.contains(opt)) return;
      if (opt.getAttribute('data-available') === 'false') return;

      var wrap = opt.closest('[data-ats-bb-choice]');
      var etait = opt.classList.contains('is-on');
      var estAucune = opt.getAttribute('data-none') === 'true';

      var opts = wrap.querySelectorAll('[data-ats-bb-choiceopt]');
      for (var i = 0; i < opts.length; i++) opts[i].classList.remove('is-on');
      wrap.classList.remove('is-missing');

      if (estAucune || etait) {
        for (var j = 0; j < opts.length; j++) {
          if (opts[j].getAttribute('data-none') === 'true') opts[j].classList.add('is-on');
        }
      } else {
        opt.classList.add('is-on');
      }

      self.evalFormConditions();
      self.refreshFormPrice();
      self.refreshModalFoot();
    });
  };

  /* ---- formats de lot ----
     Un bloc "Box · Formats" definit des lots a prix fixe (5, 10, 15...).
     Le format choisi fixe le nombre d'articles a selectionner dans les
     grilles marquees "compose le lot". A la validation, c'est le produit
     du lot qui part au panier, avec la liste des articles en proprietes. */

  BoxBuilder.prototype.bindFormats = function () {
    var self = this;

    /* Ordre de priorite : le format que le client avait choisi (memorise),
       sinon celui marque par defaut dans l'editeur, sinon le premier. */
    var depart = null;
    if (this.formatId) {
      depart = this.root.querySelector('[data-ats-bb-format][data-format-id="' + this.formatId + '"]');
    }
    if (!depart) depart = this.root.querySelector('[data-ats-bb-format][data-default="true"]');
    if (!depart) depart = this.root.querySelector('[data-ats-bb-format]');
    if (depart) this.setFormat(depart, true);

    this.setupGaugeDock();

    this.root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ats-bb-format]');
      if (btn) self.setFormat(btn);
    });
  };

  /* Sur mobile, la jauge suit le client : on la deplace dans le panneau
     ancre en bas de l'ecran, au-dessus de la barre de total. Sur ordinateur
     elle reste a sa place, sous le selecteur de format. */
  BoxBuilder.prototype.setupGaugeDock = function () {
    var jauge = this.gauge;
    var slot = this.recapBox ? this.recapBox.querySelector('[data-ats-bb-gauge-slot]') : null;
    if (!jauge || !slot) return;

    var self = this;
    var home = jauge.parentNode;

    function apply() {
      var mobile = window.innerWidth <= 900;
      var dansSlot = jauge.parentNode === slot;
      if (mobile && !dansSlot) {
        slot.appendChild(jauge);
        jauge.classList.add('ats-bb__gauge--docked');
      } else if (!mobile && dansSlot) {
        jauge.classList.remove('ats-bb__gauge--docked');
        home.appendChild(jauge);
      }
    }

    apply();
    var t = null;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(apply, 150);
    });
  };

  /* Message affiche juste sous le selecteur de format, avec remontee vers
     celui-ci : quand le lot est plein ou incomplet, le client doit voir les
     formats disponibles, pas un message en bas de page. Renvoie false si
     aucune zone de message n'existe (etape sans bloc Formats). */
  BoxBuilder.prototype.formatWarn = function (message) {
    var bloc = this.root.querySelector('[data-ats-bb-formats]');
    if (!bloc) return false;
    var node = bloc.querySelector('[data-ats-bb-format-warn]');
    if (!node) return false;

    node.textContent = message;
    node.hidden = false;

    if (bloc.scrollIntoView) bloc.scrollIntoView({ block: 'center', behavior: 'smooth' });

    clearTimeout(this.formatWarnTimer);
    this.formatWarnTimer = setTimeout(function () { node.hidden = true; }, 5000);
    return true;
  };

  BoxBuilder.prototype.setFormat = function (btn, silencieux) {
    if (!btn) return;
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 0;

    this.format = {
      id: btn.getAttribute('data-format-id'),
      qty: qty,
      variantId: btn.getAttribute('data-variant-id'),
      price: parseInt(btn.getAttribute('data-price'), 10) || 0,
      title: btn.getAttribute('data-title') || 'Lot'
    };

    var tous = this.root.querySelectorAll('[data-ats-bb-format]');
    for (var i = 0; i < tous.length; i++) tous[i].classList.remove('is-on');
    btn.classList.add('is-on');

    /* on ne garde que les premiers articles quand le format retreci */
    var duLot = this.lotItems();
    if (duLot.length > qty) {
      var trop = duLot.slice(qty);
      for (var j = 0; j < trop.length; j++) this.removeItemSilent(trop[j].uid);
    }

    if (!silencieux) this.afterChange();
  };

  /* grilles marquees "compose le lot" */
  BoxBuilder.prototype.isLotGrid = function (gridId) {
    var g = this.root.querySelector('[data-ats-bb-grid][data-grid-id="' + gridId + '"]');
    return !!g && g.getAttribute('data-lot') === 'true';
  };

  /* articles qui remplissent le lot, dans l'ordre de selection */
  BoxBuilder.prototype.lotItems = function () {
    var out = [];
    var tous = this.allItems();
    for (var i = 0; i < tous.length; i++) {
      if (this.isLotGrid(tous[i].gridId)) out.push(tous[i]);
    }
    return out;
  };

  BoxBuilder.prototype.lotCount = function () {
    var arr = this.lotItems(), n = 0;
    for (var i = 0; i < arr.length; i++) n += arr[i].qty || 1;
    return n;
  };

  BoxBuilder.prototype.lotComplet = function () {
    if (!this.format || !this.format.qty) return true;
    return this.lotCount() >= this.format.qty;
  };

  BoxBuilder.prototype.renderFormats = function () {
    /* La jauge est deplacee dans le panneau ancre sur mobile, donc hors de
       this.root : on garde sa reference plutot que de la rechercher. */
    var wrap = this.gauge;
    if (!wrap || !this.format || !this.format.qty) return;

    var total = this.format.qty;
    var n = this.lotCount();
    if (n > total) n = total;
    var reste = total - n;

    wrap.hidden = false;
    wrap.classList.toggle('is-done', reste === 0);

    var cpt = wrap.querySelector('[data-ats-bb-gauge-count]');
    if (cpt) {
      cpt.textContent = reste === 0
        ? 'Votre lot est complet'
        : n + ' sur ' + total + ' choisis';
    }

    var left = wrap.querySelector('[data-ats-bb-gauge-left]');
    if (left) {
      left.textContent = reste === 0
        ? ''
        : reste + (reste > 1 ? ' restants' : ' restant');
    }

    /* une case par article attendu : le client voit ce qu'il lui reste */
    var bar = wrap.querySelector('[data-ats-bb-gauge-bar]');
    if (bar && bar.dataset.total !== String(total)) {
      bar.dataset.total = String(total);
      bar.innerHTML = '';
      for (var i = 0; i < total; i++) {
        bar.appendChild(el('span', 'ats-bb__gaugeseg'));
      }
    }
    if (bar) {
      var segs = bar.querySelectorAll('.ats-bb__gaugeseg');
      for (var j = 0; j < segs.length; j++) {
        segs[j].classList.toggle('is-on', j < n);
      }
    }
  };

  /* Prix affiche sur les cartes du lot : ce que le client paie reellement,
     soit le prix du format divise par le nombre d'articles, avec le prix
     catalogue barre a cote. Recalcule a chaque changement de format. */
  BoxBuilder.prototype.renderLotPrices = function () {
    var grids = this.root.querySelectorAll('[data-ats-bb-grid][data-lot="true"]');
    if (!grids.length) return;

    var actif = !!(this.format && this.format.qty);
    var unitaire = actif ? Math.round(this.format.price / this.format.qty) : 0;

    for (var g = 0; g < grids.length; g++) {
      var cartes = grids[g].querySelectorAll('[data-ats-bb-card]');
      for (var i = 0; i < cartes.length; i++) {
        var node = cartes[i].querySelector('[data-ats-bb-cardprice]');
        if (!node) continue;

        var base = parseInt(cartes[i].getAttribute('data-price'), 10) || 0;

        if (!actif) {
          node.textContent = euros(base);
          continue;
        }

        var html = '<span class="ats-bb__cardnow">' + euros(unitaire) + '</span>';
        if (base > unitaire) {
          html += ' <span class="ats-bb__cardwas">' + euros(base) + '</span>';
        }
        node.innerHTML = html;
      }
    }
  };

  /* ---- onglets ----
     Shopify ne permet pas a un bloc parent de lire les reglages de ses
     blocs enfants pour construire une barre a distance. Chaque bloc
     "Box · Onglet" genere donc son propre bouton juste a cote de son
     propre panneau ; on deplace ensuite chaque bouton dans la barre
     commune au chargement, une seule fois. */

  BoxBuilder.prototype.mountOnglets = function () {
    var groups = this.root.querySelectorAll('[data-ats-bb-onglets]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var bar = group.querySelector('[data-ats-bb-ongtabs]');
      var empty = group.querySelector('[data-ats-bb-onglets-empty]');
      if (!bar || bar.dataset.mounted) continue;
      bar.dataset.mounted = '1';

      var tabs = group.querySelectorAll('[data-ats-bb-onglet-tab]');
      for (var i = 0; i < tabs.length; i++) bar.appendChild(tabs[i]);

      if (empty) empty.hidden = tabs.length > 0;

      if (tabs.length) this.activateOnglet(tabs[0], group);
    }
  };

  BoxBuilder.prototype.bindOnglets = function () {
    var self = this;
    this.mountOnglets();

    this.root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-ats-bb-onglet-tab]');
      if (!tab) return;
      var group = tab.closest('[data-ats-bb-onglets]');
      if (group) self.activateOnglet(tab, group);
    });
  };

  BoxBuilder.prototype.activateOnglet = function (tab, group) {
    if (!tab || !group) return;
    var target = tab.getAttribute('data-target');

    var tabs = group.querySelectorAll('[data-ats-bb-onglet-tab]');
    for (var i = 0; i < tabs.length; i++) tabs[i].classList.remove('is-active');
    tab.classList.add('is-active');

    var panels = group.querySelectorAll('[data-ats-bb-onglet-panel]');
    for (var j = 0; j < panels.length; j++) {
      panels[j].hidden = panels[j].getAttribute('data-block-id') !== target;
    }
  };

  BoxBuilder.prototype.bind = function () {
    var self = this;

    this.setupDock();
    this.bindGrids();
    this.bindPerso();
    this.bindOnglets();
    this.bindFormats();

    if (this.btnNext) {
      this.btnNext.addEventListener('click', function () {
        if (self.navIsCta) self.addToCart(self.btnNext);
        else self.goTo(self.current + 1);
      });
    }
    if (this.btnPrev) this.btnPrev.addEventListener('click', function () { self.goTo(self.current - 1); });
    if (this.btnBarNext) this.btnBarNext.addEventListener('click', function () { self.goTo(self.current + 1); });
    if (this.btnBarPrev) this.btnBarPrev.addEventListener('click', function () { self.goTo(self.current - 1); });

    if (this.barTrack) {
      this.barTrack.addEventListener('click', function (e) {
        var btn = e.target.closest('.ats-bb__barstep');
        if (!btn) return;
        self.goTo(parseInt(btn.getAttribute('data-pos'), 10));
      });
    }

    if (this.recapList) {
      this.recapList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove]');
        if (!btn) return;
        self.removeItem(btn.getAttribute('data-remove'));
      });
    }

    if (this.btnToggle && this.recapBox) {
      this.btnToggle.addEventListener('click', function () {
        var open = self.recapBox.classList.toggle('is-open');
        self.btnToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    if (this.btnClear) {
      this.btnClear.addEventListener('click', function () {
        if (window.confirm('Vider votre box et recommencer \u00e0 z\u00e9ro ?')) self.reset();
      });
    }

    document.addEventListener('shopify:block:select', function (e) {
      if (!self.root.contains(e.target)) return;
      var stepNode = e.target.closest('[data-ats-bb-step]');
      if (stepNode) self.goToBlockId(stepNode.getAttribute('data-block-id'));

      var ongletItem = e.target.closest('[data-ats-bb-onglet-item]');
      if (ongletItem) {
        var group = ongletItem.closest('[data-ats-bb-onglets]');
        var id = ongletItem.getAttribute('data-block-id');
        var tab = group ? group.querySelector('[data-ats-bb-onglet-tab][data-target="' + id + '"]') : null;
        if (tab) self.activateOnglet(tab, group);
      }
    });
  };

  /* ---------- init ---------- */

  var instances = [];

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ats-box-builder]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__atsbb) continue;
      var inst = new BoxBuilder(roots[i]);
      roots[i].__atsbb = inst;
      instances.push(inst);
    }
  }

  window.ATSBoxBuilder = {
    init: init,
    get: function (sectionId) {
      for (var i = 0; i < instances.length; i++) {
        if (instances[i].id === sectionId) return instances[i];
      }
      return instances[0];
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();